import {connect} from 'react-redux';
import CartVirtualEntry from './CartVirtualEntry.jsx';
import {
  handleVirtualEntryManageRosterClick,
  handleVirtualEventSelectChecked
} from './actions';

const mapStateToProps = (state, props) => {
  return {
    ...props, 
    virtualEventName: `(${props.totalEntries}) ${props.virtualEventName}`
  };
};

const mapDispatchToProps = dispatch => ({
  onManageRosterClick: (cartRosterId, virtualEntryId, virtualEntryQuantity) => dispatch(handleVirtualEntryManageRosterClick(cartRosterId, virtualEntryId, virtualEntryQuantity)),
  onSelectChecked: cartRosterId => dispatch(handleVirtualEventSelectChecked(cartRosterId))
});

export default connect(mapStateToProps, mapDispatchToProps)(CartVirtualEntry);



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/CartVirtualEntryContainer.jsx